if (!customElements.get('product-gallery-video')) {
  customElements.define('product-gallery-video', class extends HTMLElement {
    connectedCallback() {
      this.poster = this.querySelector('button');
      this.pauseOthers = () => {
        this.closest('[data-product-gallery]')?.querySelectorAll('product-gallery-video').forEach(media => {
          if (media !== this) media.pause();
        });
      };
      this.activate = (userInitiated = false) => {
        this.pauseOthers();
        let player = this.querySelector('video, iframe');
        if (!player) {
          this.append(this.querySelector('template').content.cloneNode(true));
          player = this.querySelector('video, iframe');
          if (player.tagName === 'VIDEO') player.addEventListener('play', this.pauseOthers);
        }
        this.poster.hidden = true;
        if (player.tagName === 'VIDEO') {
          if (!userInitiated) player.muted = true;
          player.play().catch(() => {
            this.poster.hidden = false;
          });
        }
        if (userInitiated) player.focus();
      };
      this.onPosterClick = () => this.activate(true);
      this.poster.addEventListener('click', this.onPosterClick);
      this.observer = new IntersectionObserver(entries => {
        this.inViewport = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
        if (this.inViewport && !document.hidden) this.activate();
        else this.pause();
      }, { threshold: 0.25 });
      this.observer.observe(this);
      this.onVisibilityChange = () => {
        if (document.hidden) this.pause();
        else if (this.inViewport) this.activate();
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    pause() {
      this.querySelector('video')?.pause();
      // Removing an external player stops playback without loading its API.
      const iframe = this.querySelector('iframe');
      if (iframe) {
        iframe.remove();
        this.poster.hidden = false;
      }
    }

    disconnectedCallback() {
      this.pause();
      this.observer?.disconnect();
      this.poster?.removeEventListener('click', this.onPosterClick);
      this.querySelector('video')?.removeEventListener('play', this.pauseOthers);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
  });
}
